import { OrganizationType } from '../interfaces/organizations';

// это нужно что бы мапить типы организаций в сервисе организаций и сервисе отзывов
export const ORGANIZATIONS_TYPE_MAP = {
  [OrganizationType.BANK]: 'banks' as OrganizationType.BANK,
  [OrganizationType.MFO]: 'mfi' as OrganizationType.MFO,
  [OrganizationType.INSURANCE]: OrganizationType.INSURANCE,
  [OrganizationType.SCHOOL]: OrganizationType.SCHOOL,
  [OrganizationType.BROKER]: OrganizationType.BROKER,
  [OrganizationType.NPF]: OrganizationType.NPF,
  [OrganizationType.LEASING]: OrganizationType.LEASING,
  [OrganizationType.MARKETPLACE]: OrganizationType.MARKETPLACE,
  [OrganizationType.BANKRUPTCY]: OrganizationType.BANKRUPTCY,
  [OrganizationType.UNIVERSITY]: OrganizationType.UNIVERSITY,
  [OrganizationType.BOOKMAKER]: OrganizationType.BOOKMAKER,
  [OrganizationType.FOOD_RATION]: OrganizationType.FOOD_RATION,
};

export const ORGANIZATION_ITEM_FIELDS = [
  '_id',
  'id',
  'alias',
  'status',
  'name',
  'fullName',
  'prepositionalName',
  'type',
  'logo',
  'roundLogo',
  'squareLogo',
  'isInsurance',
  'isBank',
  'isMfo',
  'isRecomended',
  'partnerCard',
  'license',
];

export const ORGANIZATION_ALIASES_REDIRECTS_CACHE_KEY = 'organization-aliases-redirects';
